import React from "react"

import ScheduleView from "../schedule/ScheduleView"

interface CollectionScheduleContentProps {
  selectedDate: Date
  onSelectedDateChange: (date: Date) => void
}

const CollectionScheduleContent: React.FC<CollectionScheduleContentProps> = ({
  selectedDate,
  onSelectedDateChange,
}) => {
  return (
    <ScheduleView
      scheduleType="collection"
      selectedDate={selectedDate}
      onSelectedDateChange={onSelectedDateChange}
    />
  )
}

export default CollectionScheduleContent
